/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function ActivityLogStateController($mdDialog, title, state, showingCallback) {
    var vm = this;

    vm.$onInit = function () {
        vm.activityLogStateText = null;
        vm.title = title;
        vm.close = close;

        showingCallback.onShowing = function () {
            if (state) {
                vm.activityLogStateText = angular.toJson(angular.fromJson(state), true);
            }
        };

        vm.activityLogStateOptions = {
            useWrapMode: true,
            mode: 'json',
            theme: 'github',
            advanced: {
                enableSnippets: false,
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false
            },
            showGutter: false,
            showPrintMargin: false,
            onLoad: function (_ace) {
                vm.editor = _ace;
            }
        };
    };

    function close () {
        $mdDialog.hide();
    }
}



// WEBPACK FOOTER //
// ./src/app/activity-log/activity-log-state.controller.js